import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import SuccessIcon from './assets/check-icon.svg?react';
import ErrorIcon from './assets/error-icon.svg?react';
import WarningIcon from './assets/warning-icon.svg?react';
import WaitingIcon from './assets/arrowClockwiseUpRight.svg?react';

export const Container = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    height: 48px;
    padding: 16px;
    border-bottom: 2px solid var(--gray200);
    ${(props) =>
        (props.type === 'warning' || props.type === 'waiting') &&
        css`
            background-color: var(--yellow50);
            fill: var(--yellow800);
        `};
    ${(props) =>
        props.type === 'error' &&
        css`
            background-color: var(--red50);
            fill: var(--color-error-default);
        `};
    ${(props) =>
        props.type === 'success' &&
        css`
            background-color: var(--green50);
            fill: var(--color-success-default);
        `};

    & > svg {
        min-width: 18px;
        width: 18px;
        height: 18px;
        margin-right: 8px;
    }
`;

export const Message = styled.span`
    font-size: 14px;
    color: var(--gray800);
`;

const getIconByType = (type) => {
    switch (type) {
        case 'error':
            return ErrorIcon;
        case 'warning':
            return WarningIcon;
        case 'waiting':
            return WaitingIcon;
        default:
            return SuccessIcon;
    }
};

const Snackbar = ({ type = 'success', message, showIcon = true }) => {
    const Icon = getIconByType(type);
    return (
        <Container type={type}>
            {showIcon && <Icon />}
            <Message>{message}</Message>
        </Container>
    );
};

Snackbar.propTypes = {
    type: PropTypes.oneOf(['error', 'success', 'warning', 'waiting']),
    message: PropTypes.string.isRequired,
    showIcon: PropTypes.bool,
};

export default Snackbar;
